// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const { reviver: articleReviver } = require('client-v2/common/models/article/record')
const { reviver: pageContextReviver } = require('client-v2/common/models/page-context/record')
const { keyedReviver, listReviver } = require('client-v2/common/state/revivers')
// Sibling imports
const { reviver: collectionReviver } = require('./records/collection-list-item')

class CollectionSelectModalRecord extends Immutable.Record({
  anchorId: null,
  article: null,
  articleState: FetchStateEnum.EMPTY,
  collections: Immutable.List(),
  collectionsState: FetchStateEnum.EMPTY,
  createState: FetchStateEnum.EMPTY,
  isUnmixPromptVisible: Boolean(),
  isVisible: Boolean(),
  filterText: String(),
  pageContext: null,
  unmixState: FetchStateEnum.EMPTY,
  url: String()
}) {

  setArticle(value) {
    return value
    ? this.set('article', Immutable.fromJS(value, articleReviver))
    : this.delete('article')
  }

  setCollections(value) {
    return value
    ? this.set('collections', Immutable.fromJS(value, collectionsReviver))
    : this.delete('collections')
  }

  setPageContext(value) {
    return value
    ? this.set('pageContext', Immutable.fromJS(value, pageContextReviver))
    : this.delete('pageContext')
  }

  findCollectionIndex({ id, slug }) {
    if (slug) {
      return this.collections.findIndex(c => c.slug === slug)
    }
    if (id) {
      return this.collections.findIndex(c => c.id === id)
    }
    return -1
  }

  createCollection(collection) {
    const collectionIndex = this.findCollectionIndex(collection)
    return this.update('collections', collections => {
      if (collectionIndex === -1) {
        const collectionRecord = Immutable.fromJS(collection, collectionReviver)
        return collections.unshift(collectionRecord)
      }
      return collections.update(collectionIndex, c => {
        return c.mergeDeep(collection)
      })
    })
  }

  updateCollection(collection) {
    const collectionIndex = this.findCollectionIndex(collection)
    if (collectionIndex === -1) {
      return this
    }
    return this.update('collections', collections => {
      return collections.update(collectionIndex, c => {
        return c.mergeDeep(collection)
      })
    })
  }
}

const collectionsReviver = listReviver(collectionReviver)

CollectionSelectModalRecord.reviver = keyedReviver(CollectionSelectModalRecord, {
  article: articleReviver,
  collections: collectionsReviver,
  pageContext: pageContextReviver
})

module.exports = CollectionSelectModalRecord
